import React, { useEffect, useState } from "react";
import "./StudentVerification.css";
import { Underline, Backtotop } from "../../widgets";
import {
  FaUniversity,
  FaMoneyBillWave,
  FaEnvelope,
  FaCopy,
  FaCheck,
  FaInfoCircle,
  FaCheckCircle,
  FaFileAlt,
  FaShieldAlt,
  FaPaperPlane,
} from "react-icons/fa";

const StudentVerification = () => {
  const [copiedField, setCopiedField] = useState(null);

  useEffect(() => {
    document.title = "Student Verification | ACGCET Karaikudi";
    window.scrollTo(0, 0);
  }, []);

  const copyToClipboard = (text, field) => {
    navigator.clipboard.writeText(text);
    setCopiedField(field);
    setTimeout(() => {
      setCopiedField(null);
    }, 2500);
  };

  const accountDetails = {
    accountName: "The Principal, ACCET",
    bankName: "Canara Bank",
    branch: "Karaikudi",
    accountNumber: "0903101079831",
    ifscCode: "CNRB0000903",
    fee: "Rs. 500/-",
    email: "coe@accet.ac.in",
  };


  return (
    <div className="student-verify-page">
      {/* Page Header Banner */}
      <div className="student-verify-banner">
        <div className="student-verify-banner-content">
          
          <h1 className="student-verify-title">Student Verification</h1>
          <p className="student-verify-subtitle">
            Alagappa Chettiar Government College of Engineering and Technology
            (Autonomous), Karaikudi
          </p>
          <p className="student-verify-office">
            Office of the Controller of Examinations (COE)
          </p>
        </div>
      </div>

      <div className="student-verify-container">
        {/* Intro description */}
        <div className="verify-intro-card">
          <div className="intro-icon-wrap">
            <FaInfoCircle className="intro-icon" />
          </div>
          <div className="intro-text">
            <h3>Credential & Education Verification Guidelines</h3>
            <p>
              Prospective employers, screening agencies, universities, and
              institutions seeking genuine certificate / credential verification
              of alumni and students graduated from ACGCET Karaikudi are
              requested to remit the prescribed verification fee and submit
              their request along with necessary academic records as outlined
              below.
            </p>
          </div>
        </div>

        {/* Quick Highlights Grid */}
        <div className="verify-highlight-grid">
          <div className="highlight-card fee-card">
            <div className="highlight-icon-box fee-icon-box">
              <FaMoneyBillWave />
            </div>
            <div className="highlight-info">
              <span className="highlight-label">Verification Fee</span>
              <span className="highlight-value">{accountDetails.fee}</span>
              <span className="highlight-hint">per student / candidate</span>
            </div>
          </div>

          <div className="highlight-card email-card">
            <div className="highlight-icon-box email-icon-box">
              <FaEnvelope />
            </div>
            <div className="highlight-info">
              <span className="highlight-label">Official Submission Email</span>
              <a
                href={`mailto:${accountDetails.email}`}
                className="highlight-value-email"
              >
                {accountDetails.email}
              </a>
              <span className="highlight-hint">Controller of Examinations</span>
            </div>
          </div>

          <div className="highlight-card bank-card">
            <div className="highlight-icon-box bank-icon-box">
              <FaUniversity />
            </div>
            <div className="highlight-info">
              <span className="highlight-label">Remittance Bank</span>
              <span className="highlight-value">
                {accountDetails.bankName}, {accountDetails.branch}
              </span>
              <span className="highlight-hint">NEFT / RTGS / IMPS Accepted</span>
            </div>
          </div>
        </div>

        {/* Main Section: Bank Account Details */}
        <div className="verify-section">
          <Underline heading="Bank Account Particulars" />
          <p className="section-note">
            Account particulars for verification fee payment are given below.
            Please ensure the transaction reference (UTR) is captured for email
            submission.
          </p>

          <div className="account-details-card">
            <div className="account-details-header">
              <div className="acc-header-title">
                <FaUniversity className="acc-icon" />
                <div>
                  <h4>Remittance Account Information</h4>
                  <p>All fees must be directly credited to this official account</p>
                </div>
              </div>
              <div className="fee-badge-pill">
                Fee: <strong>Rs. 500/-</strong>
              </div>
            </div>

            <div className="account-grid">
              <div className="account-item">
                <span className="account-item-label">Name of the Account</span>
                <span className="account-item-value highlight-bold">
                  {accountDetails.accountName}
                </span>
              </div>

              <div className="account-item">
                <span className="account-item-label">Bank Name</span>
                <span className="account-item-value">
                  {accountDetails.bankName}
                </span>
              </div>

              <div className="account-item">
                <span className="account-item-label">Branch</span>
                <span className="account-item-value">
                  {accountDetails.branch}
                </span>
              </div>

              <div className="account-item copyable-item">
                <div>
                  <span className="account-item-label">Account Number (A/C No.)</span>
                  <span className="account-item-value mono-val">
                    {accountDetails.accountNumber}
                  </span>
                </div>
                <button
                  type="button"
                  className={`copy-btn ${
                    copiedField === "acc" ? "copied" : ""
                  }`}
                  onClick={() =>
                    copyToClipboard(accountDetails.accountNumber, "acc")
                  }
                  title="Copy Account Number"
                >
                  {copiedField === "acc" ? (
                    <>
                      <FaCheck /> Copied!
                    </>
                  ) : (
                    <>
                      <FaCopy /> Copy
                    </>
                  )}
                </button>
              </div>

              <div className="account-item copyable-item">
                <div>
                  <span className="account-item-label">IFSC Code</span>
                  <span className="account-item-value mono-val">
                    {accountDetails.ifscCode}
                  </span>
                </div>
                <button
                  type="button"
                  className={`copy-btn ${
                    copiedField === "ifsc" ? "copied" : ""
                  }`}
                  onClick={() =>
                    copyToClipboard(accountDetails.ifscCode, "ifsc")
                  }
                  title="Copy IFSC Code"
                >
                  {copiedField === "ifsc" ? (
                    <>
                      <FaCheck /> Copied!
                    </>
                  ) : (
                    <>
                      <FaCopy /> Copy
                    </>
                  )}
                </button>
              </div>

              <div className="account-item">
                <span className="account-item-label">Verification Fee</span>
                <span className="account-item-value fee-amount">
                  {accountDetails.fee}
                </span>
              </div>

              <div className="account-item full-width-item copyable-item">
                <div>
                  <span className="account-item-label">Official Mail ID</span>
                  <a
                    href={`mailto:${accountDetails.email}`}
                    className="account-item-value mail-link"
                  >
                    {accountDetails.email}
                  </a>
                </div>
                <button
                  type="button"
                  className={`copy-btn ${
                    copiedField === "mail" ? "copied" : ""
                  }`}
                  onClick={() =>
                    copyToClipboard(accountDetails.email, "mail")
                  }
                  title="Copy Mail ID"
                >
                  {copiedField === "mail" ? (
                    <>
                      <FaCheck /> Copied!
                    </>
                  ) : (
                    <>
                      <FaCopy /> Copy
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Verification Procedure Steps */}
        <div className="verify-section">
          <Underline heading="Procedure for Verification" />
          <div className="steps-container">
            <div className="step-card">
              <div className="step-number">1</div>
              <div className="step-content">
                <h5>Pay Verification Fee</h5>
                <p>
                  Remit the verification fee of <strong>Rs. 500/-</strong> per
                  candidate to the Canara Bank account mentioned above using
                  NEFT, RTGS, IMPS, or Net Banking.
                </p>
              </div>
            </div>

            {/* <div className="step-card">
              <div className="step-number">2</div>
              <div className="step-content">
                <h5>Compile Required Documents</h5>
                <p>
                  Prepare clear scanned copies (PDF/JPEG) of the documents to be
                  verified (Degree Certificate, Provisional Certificate, or
                  Consolidated Marksheet) along with the verification request
                  form or letter on official letterhead.
                </p>
              </div>
            </div> */}

            <div className="step-card">
              <div className="step-number">2</div>
              <div className="step-content">
                <h5>Send Verification Request by Email</h5>
                <p>
                  Email the basic details along with the bank transaction receipt /
                  UTR reference number to{" "}
                  <a
                    href={`mailto:${accountDetails.email}`}
                    className="inline-email-link"
                  >
                    {accountDetails.email}
                  </a>
                  . Mention the student's Name and Register Number clearly in
                  the subject.
                </p>
              </div>
            </div>

            <div className="step-card">
              <div className="step-number">3</div>
              <div className="step-content">
                <h5>Processing & Authentication</h5>
                <p>
                  The Office of the Controller of Examinations will verify the
                  records against the institutional registry and provide the
                  official verification report via return email.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA / Quick Email Box */}
        <div className="verify-cta-card">
          <div className="cta-content">
            <h4>Ready to submit a verification request?</h4>
            <p>
              Click below to send an email directly to{" "}
              <strong>{accountDetails.email}</strong>.
            </p>
          </div>
          <a
            href={`mailto:${accountDetails.email}`}
            className="cta-button"
          >
            <FaPaperPlane className="cta-btn-icon" /> Send Verification Email
          </a>
        </div>

        {/* Important Guidelines Checklist */}
        <div className="verify-guidelines-box">
          <h5>
            <FaCheckCircle className="guideline-icon" /> Important Guidelines
          </h5>
          <ul>
            <li>
              Please specify the candidate’s full name, register number, and
              department in the email subject.
            </li>
            <li>
              Ensure the payment proof clearly shows the <strong>UTR / Transaction Reference Number</strong>, payment date, and remitted amount.
            </li>
            <li>
              Verification requests received without proof of fee payment will
              not be processed.
            </li>
            <li>
              For any urgent inquiries regarding verification status, kindly
              contact the Office of the Controller of Examinations (COE) via{" "}
              <strong>coe@accet.ac.in</strong>.
            </li>
          </ul>
        </div>
      </div>
      <Backtotop />
    </div>
  );
};

export default StudentVerification;
